(function () {
  /* sticky header shadow */
  var header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  /* quantity steppers (plain .qty only — <quantity-input> handles itself) */
  document.querySelectorAll('.qty').forEach(function (q) {
    if (q.tagName.toLowerCase() === 'quantity-input') return;
    var input = q.querySelector('input'), b = q.querySelectorAll('button');
    if (!input || b.length < 2) return;
    b[0].onclick = function () { input.value = Math.max(1, (parseInt(input.value) || 1) - 1); };
    b[1].onclick = function () { input.value = (parseInt(input.value) || 1) + 1; };
  });

  /* cart badge helpers */
  var badge = document.querySelector('.header .badge');
  function setBadge(count) { if (badge) badge.textContent = count; }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setBadge(c.item_count); })
      .catch(function () {});
  }

  /* Add-to-cart is handled by the <product-form> element (assets/product-form.js),
     which also refreshes the badge. Placeholder buttons (type="button", no form)
     are inert by design. refreshCart()/setBadge kept for other callers. */
  void refreshCart; void setBadge;

  /* cartridge finder — merchant-editable brand/series/model data lives on the section */
  var finder = document.querySelector('[data-finder]');
  var fb = document.getElementById('f-brand'),
      fs = document.getElementById('f-series'),
      fm = document.getElementById('f-model');
  var data = {};
  if (finder) {
    try { data = JSON.parse(finder.getAttribute('data-finder') || '{}'); } catch (e) { data = {}; }
  }
  function fill(sel, items, ph) {
    sel.innerHTML = '<option value="">' + ph + '</option>' +
      items.map(function (i) { return '<option>' + i + '</option>'; }).join('');
    sel.disabled = false;
  }
  function reset(sel, ph) { sel.innerHTML = '<option>' + ph + '</option>'; sel.disabled = true; }
  if (fb && fs && fm) {
    fb.addEventListener('change', function () {
      reset(fm, 'Select series first');
      if (data[this.value]) { fill(fs, Object.keys(data[this.value]), 'Choose a series'); }
      else { reset(fs, 'Select brand first'); }
    });
    fs.addEventListener('change', function () {
      var b = fb.value;
      if (data[b] && data[b][this.value]) { fill(fm, data[b][this.value], 'Choose your model'); }
      else { reset(fm, 'Select series first'); }
    });
  }
  var fgo = document.querySelector('.fgo');
  if (fgo) {
    fgo.addEventListener('click', function () {
      if (fb && !fb.value) { fb.focus(); return; }
      var q = [fb && fb.value, fs && fs.value, fm && fm.value].filter(Boolean).join(' ');
      if (q) { window.location.href = '/search?q=' + encodeURIComponent(q); }
    });
  }

  /* brand tabs */
  document.querySelectorAll('.btab-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      var scope = b.closest('.wrap') || document;
      var t = b.dataset.tab;
      scope.querySelectorAll('.btab-btn').forEach(function (x) { x.classList.toggle('active', x === b); });
      scope.querySelectorAll('.btab-panel').forEach(function (p) { p.classList.toggle('active', p.dataset.panel === t); });
    });
  });
})();
